import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M9.00016 14.2912L2.1565 3.53688C1.73285 2.87115 2.21107 2 3.00016 2H21.0002C21.7892 2 22.2675 2.87115 21.8438 3.53688L15.0002 14.2912V19C15.0002 19.3788 14.7862 19.725 14.4474 19.8944L10.4474 21.8944C9.78247 22.2269 9.00016 21.7434 9.00016 21V14.2912ZM4.82183 4L10.8438 13.4631C10.9459 13.6236 11.0002 13.8098 11.0002 14V19.382L13.0002 18.382V14C13.0002 13.8098 13.0544 13.6236 13.1565 13.4631L19.1785 4H4.82183Z" />,
  'Filter'
);
